import React from "react";
import { Button, Grid, Paper, Typography } from "@material-ui/core/index";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { prm } from "../../../mocks";

export default function BottomView(props) {
  const classes = styles();
  const { selectedPassenger } = props;

  if (selectedPassenger) {
    return (
      <Paper square className={classes.container}>
        <Typography className={classes.visualizing}>Passeggero</Typography>
        <Typography className={classes.passengerName}>
          {selectedPassenger.name} {selectedPassenger.surname}
        </Typography>
        <Typography className={classes.visualizing}>
          Dettaglio biglietto
        </Typography>
        <Typography className={classes.passengerName}>
          {selectedPassenger.ticketCode} - {selectedPassenger.destination} |
          Gate: {selectedPassenger.gate} | {selectedPassenger.time}
        </Typography>
        <Typography className={classes.visualizing}>Tipologia PRM</Typography>
        <Typography className={classes.passengerName}>
          {selectedPassenger.type}
        </Typography>
      </Paper>
    );
  } else {
    return (
      <Paper square className={classes.container}>
        <Button
          className={classes.groundButton}
          aria-controls="fade-menu"
          aria-haspopup="true"
          endIcon={<ArrowDropDownIcon className={classes.arrowDropDown} />}
        >
          Piano terra
        </Button>
        <Typography className={classes.visualizing}>
          Stai visualizzando
        </Typography>
        <Grid container direction="row" alignItems={"flex-end"}>
          <Typography
            variant="h4"
            className={classes.prmNumber}
          >{`${prm.length}/${prm.length}`}</Typography>
          <Typography className={classes.prmText}>prm</Typography>
        </Grid>
      </Paper>
    );
  }
}

const styles = makeStyles(theme => ({
  container: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.primary.main,
    padding: 10,
    margin: 10
  },
  groundButton: {
    textTransform: "none",
    color: theme.palette.white
  },
  arrowDropDown: {
    color: theme.palette.white
  },
  visualizing: {
    color: theme.palette.white,
    marginLeft: 7,
    fontSize: "small",
    fontWeight: "100"
  },
  prmNumber: {
    color: theme.palette.secondary.main,
    marginLeft: 7,
    fontSize: 40,
    fontWeight: "900"
  },
  prmText: {
    color: theme.palette.secondary.main,
    marginLeft: 7,
    marginBottom: 5,
    fontWeight: "500"
  },
  passengerName: {
    color: theme.palette.white,
    marginLeft: 7,
    marginBottom: 10,
    fontSize: 16,
    fontWeight: "800"
  }
}));
